(function () {
  if (window.GneisServicePointSelectorLoaded) return;
  window.GneisServicePointSelectorLoaded = true;

  var ROOT_SELECTOR = '[data-gneis-service-point-selector]';

  function enableDrawerResultTouchScroll() {
    document.querySelectorAll('#drawer-cart [data-gneis-service-point-results]').forEach(function (results) {
      if (results.dataset.gneisTouchScrollEnabled === 'true') return;

      results.dataset.gneisTouchScrollEnabled = 'true';

      results.addEventListener('touchmove', function (event) {
        event.stopPropagation();
      }, { passive: true });
    });
  }

  function closestSelector(element) {
    return element ? element.closest(ROOT_SELECTOR) : null;
  }

  function cleanPostalCode(value) {
    return String(value || '').replace(/\s/g, '').trim();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getText(container, key) {
    if (!container) return '';
    return container.getAttribute('data-i18n-' + key) || '';
  }

  function formatTemplate(template, values) {
    return String(template || '').replace(/\|\|([a-z_]+)\|\|/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : match;
    });
  }

  function formatDistance(container, distanceMeters) {
    var distance = Number(distanceMeters);

    if (!Number.isFinite(distance)) return '';

    var locale = container.getAttribute('data-locale') || document.documentElement.lang || 'en';

    if (distance >= 1000) {
      var kilometres = (distance / 1000).toLocaleString(locale, {
        maximumFractionDigits: 1
      });
      return formatTemplate(getText(container, 'distance-km'), { distance: kilometres });
    }

    return formatTemplate(getText(container, 'distance-m'), { distance: Math.round(distance) });
  }

  function setStatus(container, message, type) {
    var status = container.querySelector('[data-gneis-service-point-status]');
    if (!status) return;

    status.textContent = message || '';
    status.classList.remove(
      'gneis-service-point__status--error',
      'gneis-service-point__status--success'
    );

    if (type === 'error') {
      status.classList.add('gneis-service-point__status--error');
    }

    if (type === 'success') {
      status.classList.add('gneis-service-point__status--success');
    }
  }

  function setLoading(container, isLoading) {
    var submit = container.querySelector('[data-gneis-service-point-search-button]');
    var selectButtons = container.querySelectorAll('[data-gneis-service-point-select]');

    if (submit) {
      submit.disabled = isLoading;
      submit.textContent = isLoading ? getText(container, 'loading') : getText(container, 'fetch');
    }

    selectButtons.forEach(function (button) {
      button.disabled = isLoading;
    });
  }

  function renderResults(container, points, searchedPostalCode) {
    var results = container.querySelector('[data-gneis-service-point-results]');
    if (!results) return;

    container.__gneisServicePoints = points || [];
    container.__gneisSearchedPostalCode = searchedPostalCode || '';

    if (!points || !points.length) {
      results.innerHTML = '';
      results.scrollTop = 0;
      return;
    }

    results.innerHTML = points.map(function (point, index) {
      var addressLine = [
        point.address,
        [point.postal_code, point.city].filter(Boolean).join(' ')
      ].filter(Boolean).join(', ');

      var distance = formatDistance(container, point.distance_m);
      var openingHours = point.opening_hours_short
        ? getText(container, 'open') + ': ' + point.opening_hours_short
        : '';

      return [
        '<div class="gneis-service-point__result">',
          '<div class="gneis-service-point__result-main">',
            '<span class="gneis-service-point__result-name">' + escapeHtml(point.name) + '</span>',
            '<span>' + escapeHtml(addressLine) + '</span>',
            distance ? '<span class="gneis-service-point__result-meta">' + escapeHtml(distance) + '</span>' : '',
            openingHours ? '<span class="gneis-service-point__result-meta">' + escapeHtml(openingHours) + '</span>' : '',
          '</div>',
          '<button class="gneis-service-point__select" type="button" data-gneis-service-point-select="' + index + '">',
            escapeHtml(getText(container, 'select')),
          '</button>',
        '</div>'
      ].join('');
    }).join('');

    results.scrollTop = 0;
  }

  function showSearch(container) {
    var search = container.querySelector('[data-gneis-service-point-search]');
    var selected = container.querySelector('[data-gneis-service-point-selected]');
    var results = container.querySelector('[data-gneis-service-point-results]');

    container.__gneisServicePointHydrateSuppressedUntil = Date.now() + 30000;

    if (search) search.hidden = false;
    if (selected) selected.hidden = true;
    if (results) results.innerHTML = '';

    setStatus(container, '', '');
  }

  function showSelected(container, attributes) {
    var search = container.querySelector('[data-gneis-service-point-search]');
    var selected = container.querySelector('[data-gneis-service-point-selected]');
    var results = container.querySelector('[data-gneis-service-point-results]');

    var name = attributes['Gneis ombud namn'] || '';
    var address = attributes['Gneis ombud adress'] || '';
    var postalCode = attributes['Gneis ombud postnummer'] || '';
    var city = attributes['Gneis ombud ort'] || '';

    var nameEl = container.querySelector('[data-gneis-service-point-selected-name]');
    var addressEl = container.querySelector('[data-gneis-service-point-selected-address]');
    var hoursEl = container.querySelector('[data-gneis-service-point-selected-hours]');

    if (nameEl) nameEl.textContent = name;

    if (addressEl) {
      addressEl.textContent = [
        address,
        [postalCode, city].filter(Boolean).join(' ')
      ].filter(Boolean).join(', ');
    }

    if (hoursEl) {
      hoursEl.textContent = '';
      hoursEl.hidden = true;
    }

    if (selected) selected.hidden = false;
    if (search) search.hidden = true;
    if (results) results.innerHTML = '';

    setStatus(container, '', '');
  }

  function showSavedServicePointFromCart(container, cart) {
    var attributes = cart && cart.attributes ? cart.attributes : {};
    var servicePointCode = String(attributes.GneisServicePointCode || '');
    var servicePointName = String(attributes.GneisServicePointName || '');

    if (!servicePointCode || !servicePointName) return false;

    if (
      container.__gneisServicePointHydrateSuppressedUntil &&
      Date.now() < container.__gneisServicePointHydrateSuppressedUntil
    ) {
      return false;
    }

    var selected = container.querySelector('[data-gneis-service-point-selected]');
    var selectedNameEl = container.querySelector('[data-gneis-service-point-selected-name]');

    if (
      selected &&
      !selected.hidden &&
      selectedNameEl &&
      selectedNameEl.textContent.trim() === servicePointName
    ) {
      return true;
    }

    showSelected(container, {
      'Gneis ombud namn': servicePointName,
      'Gneis ombud adress': getText(container, 'service-point-id') + ': ' + servicePointCode,
      'Gneis ombud postnummer': '',
      'Gneis ombud ort': '',
      'Gneis ombud öppettider': ''
    });

    return true;
  }

  function hydrateSavedServicePoint(container) {
    if (!container) return;

    getCart(container)
      .then(function (cart) {
        if (!cart || !cart.item_count) return;

        showSavedServicePointFromCart(container, cart);
      })
      .catch(function () {
        // Ignore. Customer can still search and choose service point manually.
      });
  }

  function hydrateAllSavedServicePoints() {
    enableDrawerResultTouchScroll();

    document.querySelectorAll(ROOT_SELECTOR).forEach(function (container) {
      hydrateSavedServicePoint(container);
    });
  }

  function getCartUpdateUrl(container) {
    return container.getAttribute('data-cart-update-url') || '';
  }

  function getCartUrl(container) {
    return container.getAttribute('data-cart-url') || '';
  }

  function getCart(container) {
    return fetch(getCartUrl(container), {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(getText(container, 'cart-read-error'));
      }

      return response.json();
    });
  }

  function cleanOldGneisOmbudNote(note) {
    var currentNote = String(note || '');
    var trimmedNote = currentNote.trim();

    if (!trimmedNote) return null;

    if (
      trimmedNote.indexOf('OMBUD:') === 0 &&
      trimmedNote.indexOf('Ombud ID:') !== -1
    ) {
      return '';
    }

    if (
      trimmedNote.indexOf('--- GNEIS OMBUD START ---') !== -1 &&
      trimmedNote.indexOf('--- GNEIS OMBUD END ---') !== -1
    ) {
      return currentNote
        .replace(/--- GNEIS OMBUD START ---[\s\S]*?--- GNEIS OMBUD END ---/g, '')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
    }

    return null;
  }

  function updateCartAttributes(container, attributes) {
    return getCart(container).then(function (cart) {
      var formData = new FormData();
      var cleanedNote = cleanOldGneisOmbudNote(cart.note || '');

      Object.keys(attributes).forEach(function (key) {
        formData.append('attributes[' + key + ']', attributes[key]);
      });

      if (cleanedNote !== null) {
        formData.append('note', cleanedNote);
      }

      return fetch(getCartUpdateUrl(container), {
        method: 'POST',
        headers: {
          'Accept': 'application/json'
        },
        body: formData
      });
    }).then(function (response) {
      if (!response.ok) {
        throw new Error(getText(container, 'cart-save-error'));
      }

      return response.json();
    }).then(function () {
      return getCart(container);
    }).then(function (cart) {
      var cartAttributes = cart.attributes || {};

      if (
        String(cartAttributes.GneisServicePointCode || '') !== String(attributes.GneisServicePointCode || '') ||
        String(cartAttributes.GneisServicePointName || '') !== String(attributes.GneisServicePointName || '')
      ) {
        throw new Error(getText(container, 'cart-verify-error'));
      }

      return cart;
    });
  }

  function friendlyFetchError(container, error) {
    var message = error && error.message ? error.message : '';

    if (
      message.indexOf('postal_code') !== -1 ||
      message.indexOf('Schenker') !== -1 ||
      message.indexOf('Ombudsservern') !== -1 ||
      message.indexOf('Failed to fetch') !== -1 ||
      message.indexOf('Load failed') !== -1
    ) {
      return getText(container, 'fetch-error-postal');
    }

    return getText(container, 'fetch-error-generic');
  }

  function fetchServicePoints(container, postalCode) {
    var proxyUrl = container.getAttribute('data-proxy-url') || '/apps/gneis-ombud/service-points';
    var url = proxyUrl +
      '?postal_code=' + encodeURIComponent(postalCode) +
      '&carrier=schenker' +
      '&amount=5';

    return fetch(url, {
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (response) {
      return response.text().then(function (text) {
        var data = null;

        try {
          data = text ? JSON.parse(text) : null;
        } catch (error) {
          throw new Error(getText(container, 'fetch-error-generic'));
        }

        if (!data) {
          throw new Error(getText(container, 'fetch-error-generic'));
        }

        if (!response.ok || !data.ok) {
          throw new Error(getText(container, 'fetch-error-generic'));
        }

        return data;
      });
    });
  }

  function handleServicePointSearch(form) {
    var container = closestSelector(form);
    if (!container) return;

    var input = form.querySelector('[name="postal_code"]');
    var postalCode = cleanPostalCode(input ? input.value : '');

    if (!/^\d{5}$/.test(postalCode)) {
      renderResults(container, [], postalCode);
      setStatus(container, getText(container, 'invalid-postal'), 'error');
      return;
    }

    setLoading(container, true);
    setStatus(container, getText(container, 'loading-nearest'), '');

    fetchServicePoints(container, postalCode)
      .then(function (data) {
        var points = data.service_points || [];

        if (!points.length) {
          renderResults(container, [], postalCode);
          setStatus(
            container,
            getText(container, 'no-points'),
            'error'
          );
          return;
        }

        renderResults(container, points, postalCode);
        setStatus(container, getText(container, 'choose-scroll'), '');
      })
      .catch(function (error) {
        renderResults(container, [], postalCode);
        setStatus(container, friendlyFetchError(container, error), 'error');
      })
      .finally(function () {
        setLoading(container, false);
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-gneis-service-point-form]');
    if (!form) return;

    event.preventDefault();
    handleServicePointSearch(form);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    var form = event.target.closest('[data-gneis-service-point-form]');
    if (!form) return;

    event.preventDefault();
    handleServicePointSearch(form);
  });

  document.addEventListener('click', function (event) {
    var searchButton = event.target.closest('[data-gneis-service-point-search-button]');

    if (searchButton) {
      var searchForm = searchButton.closest('[data-gneis-service-point-form]');
      if (searchForm) handleServicePointSearch(searchForm);
      return;
    }

    var changeButton = event.target.closest('[data-gneis-service-point-change]');

    if (changeButton) {
      var changeContainer = closestSelector(changeButton);
      if (changeContainer) showSearch(changeContainer);
      return;
    }

    var selectButton = event.target.closest('[data-gneis-service-point-select]');

    if (!selectButton) return;

    var container = closestSelector(selectButton);
    if (!container) return;

    var index = Number(selectButton.getAttribute('data-gneis-service-point-select'));
    var point = container.__gneisServicePoints && container.__gneisServicePoints[index];

    if (!point) {
      setStatus(container, getText(container, 'point-read-error'), 'error');
      return;
    }

    var savedAttributes = {
      'GneisServicePointCode': String(point.id || ''),
      'GneisServicePointName': String(point.name || '')
    };

    var displayAttributes = {
      'Gneis ombud namn': String(point.name || ''),
      'Gneis ombud adress': String(point.address || ''),
      'Gneis ombud postnummer': String(point.postal_code || ''),
      'Gneis ombud ort': String(point.city || ''),
      'Gneis ombud öppettider': String(point.opening_hours_short || '')
    };

    setLoading(container, true);
    setStatus(container, getText(container, 'saving'), '');

    updateCartAttributes(container, savedAttributes)
      .then(function () {
        container.__gneisServicePointHydrateSuppressedUntil = 0;

        showSelected(container, displayAttributes);

        document.dispatchEvent(new CustomEvent('gneis:service-point:change'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:cart:change'));
      })
      .catch(function (error) {
        setStatus(container, error.message || getText(container, 'cart-save-error'), 'error');
      })
      .finally(function () {
        setLoading(container, false);
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(hydrateAllSavedServicePoints, 100);
      setTimeout(hydrateAllSavedServicePoints, 500);
      setTimeout(hydrateAllSavedServicePoints, 1000);
    });
  } else {
    setTimeout(hydrateAllSavedServicePoints, 100);
    setTimeout(hydrateAllSavedServicePoints, 500);
    setTimeout(hydrateAllSavedServicePoints, 1000);
  }

  document.addEventListener('cart:refresh', function () {
    setTimeout(hydrateAllSavedServicePoints, 250);
    setTimeout(hydrateAllSavedServicePoints, 750);
    setTimeout(hydrateAllSavedServicePoints, 1200);
  });

  document.addEventListener('theme:cart:change', function () {
    setTimeout(hydrateAllSavedServicePoints, 250);
    setTimeout(hydrateAllSavedServicePoints, 750);
    setTimeout(hydrateAllSavedServicePoints, 1200);
  });

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('[data-drawer-toggle="drawer-cart"]') ||
      event.target.closest('[href*="/cart"]') ||
      event.target.closest('.cart-link')
    ) {
      setTimeout(hydrateAllSavedServicePoints, 250);
      setTimeout(hydrateAllSavedServicePoints, 750);
      setTimeout(hydrateAllSavedServicePoints, 1200);
    }
  });
})();